import React from 'react';
import MultiFileUploader from '@/components/Upload/MultiFileUploader';
import { Controller, useFormContext } from 'react-hook-form';
import { useRHFFileUpload } from '@/hooks/useRHFFileUpload';

const SingleZipFileUpload: React.FC<{
  name: string;
  hideDropzone?: boolean;
}> = ({ name, hideDropzone }) => {
  const { control } = useFormContext();
  const { handleSetSingleValue } = useRHFFileUpload(name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <MultiFileUploader
            value={field.value ? [field.value] : []}
            setValue={handleSetSingleValue}
            isOnlyImage={false}
            previewType={'filename'}
            useAddButton={false}
            upload={true}
            maxSize={500 * 1024 * 1024}
            maxLength={1}
            placeHolder={
              '파일을 이곳에 끌어다 놓거나 아래 버튼을 눌러 추가해 주세요.'
            }
            sortable={false}
            hideDropzone={hideDropzone}
            accept={{
              'application/zip': ['.zip'],
              'text/html': ['.html'],
            }}
          />
        );
      }}
    />
  );
};

export default SingleZipFileUpload;
